import { I18n } from 'react-redux-i18n';
const timesearchFields = (searchFieldValues, min, max, startDatemaxValue) => {
    return {
        rows: [
            {
                hasTopBreak: false,
                hasBottomBreak: false,
                fields: [
                    {
                        id: "StartDate",
                        label: "Start Date",
                        type: "date",
                        value: searchFieldValues?.StartDate?.value,
                        max:  startDatemaxValue
                        
                    },
                    {
                        id: "EndDate",
                        label: "End Date",
                        type: "date",
                        value: searchFieldValues?.EndDate?.value,
                        /*  min : searchFieldValues?.StartDate?.value */
                        min: min,
                        max: max
                    },
              /*       {
                        id: "WorkingHoursFrom",
                        label: "Working Hours From",
                        type: "time",
                        value: searchFieldValues?.WorkingHoursFrom?.value,
                    },
                    {
                        id: "WorkingHoursEnd",
                        label: "Working Hours End",
                        type: "time",
                        value: searchFieldValues?.WorkingHoursEnd?.value,
                    }, */
                ]
            },

        ]
    }
};

export {
    timesearchFields
}